import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/policies/edit/$id')({
  beforeLoad: () => getTitleContextSlice('Edit Policy'),
  staticData: {
    owner: CodeOwner.Assets,
  },
});
